import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { eligibilityQueryOptions } from "@/app/onboarding/api/get-eligibility";
import { onboardingProgressQueryOptions } from "@/app/onboarding/api/get-onboarding-progress";
import { canEnterOnboardingRoute } from "@/app/onboarding/lib/selectors";
import { OnboardingOverlay } from "@/app/onboarding-first-win/components/onboarding-overlay";
import { OnboardingOverlaySkeleton } from "@/app/onboarding-first-win/components/onboarding-overlay-skeleton";
import { OnboardingUnavailable } from "@/app/onboarding-first-win/components/onboarding-unavailable";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/onboarding"
)({
  loader: async ({ params, context }) => {
    const eligibility = await context.queryClient.ensureQueryData(
      eligibilityQueryOptions(params.organizationId, params.projectId)
    );

    if (canEnterOnboardingRoute(eligibility)) {
      await context.queryClient.ensureQueryData(
        onboardingProgressQueryOptions(params.organizationId, params.projectId)
      );
    }
  },
  pendingComponent: OnboardingOverlaySkeleton,
  component: OnboardingRouteGate,
});

function OnboardingRouteGate(): JSX.Element {
  const { organizationId, projectId } = Route.useParams();
  const { data: eligibility } = useSuspenseQuery(
    eligibilityQueryOptions(organizationId, projectId)
  );

  if (!canEnterOnboardingRoute(eligibility)) {
    return (
      <OnboardingUnavailable
        organizationId={organizationId}
        projectId={projectId}
      />
    );
  }

  return <OnboardingOverlay />;
}
